<script>
  function getClass (classname) {
    return document.getElementsByClassName(classname)
  }
  var poisArr = []
  export default {
    getClass,
    poisArr
  }
</script>


// WEBPACK FOOTER //
// methodCommon.vue?1f543297